import { useEffect } from 'react';
import { setConsent } from '../utils/cookieConsent';
import { PRIVACY_URL } from '../constants/links';

export default function CookieBanner({ onAccept, onShowSettings }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleAccept = () => {
    setConsent(); // Only functional cookies
    onAccept && onAccept();
  };

  const handleAcceptAll = () => {
    setConsent({ marketing: true }); // Functional + marketing cookies
    // Dispatch event to notify Google Ads hook
    window.dispatchEvent(new Event('cookieConsentChanged'));
    onAccept && onAccept();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, pointerEvents: 'none' }}>
      <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(17,24,39,0.22)', pointerEvents: 'auto' }} />
      <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, pointerEvents: 'auto' }}>
        <div style={{ background: 'rgba(255,255,255,0.94)', borderTop: '1px solid rgba(229,231,235,0.95)', boxShadow: '0 -18px 40px rgba(17,24,39,0.12)', backdropFilter: 'blur(14px)' }}>
          <div style={{ maxWidth: 1120, margin: '0 auto', padding: '24px 16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'stretch' }}>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0, marginBottom: 8, fontFamily: 'var(--font-heading)' }}>Cookies & Datenschutz</h3>
                <p style={{ margin: 0, color: '#374151', lineHeight: 1.6, fontSize: 14 }}>
                  Wir verwenden funktionale Cookies, um Ihre Einstellungen während der Browser-Sitzung zu speichern. Diese sind für die
                  ordnungsgemäße Funktion unserer Website erforderlich und werden von <strong>LRH Software UG (haftungsbeschränkt)</strong> gesetzt.
                </p>
                <p style={{ margin: '8px 0 0 0', color: '#374151', lineHeight: 1.6, fontSize: 14 }}>
                  Optional verwenden wir auch Marketing-Cookies (Google Ads, OpenAI Ads) zur Conversion-Messung und Werbung. Diese werden von Google Ireland Ltd. und OpenAI Ireland Ltd. gesetzt und nur mit Ihrer Einwilligung geladen.
                </p>
                <p style={{ margin: '8px 0 0 0', color: '#6b7280', fontSize: 12 }}>
                  Speicherdauer: Funktionale Cookies bis zum Ende der Browser-Sitzung • Marketing-Cookies: 90 Tage •{' '}
                  <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={{ color: '#15803d', textDecoration: 'underline' }}>Datenschutzerklärung</a>
                </p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <button
                  onClick={onShowSettings}
                  style={{
                    padding: '10px 16px', fontSize: 14, fontWeight: 600, color: '#374151', background: '#fff', border: '1px solid #d1d5db',
                    borderRadius: 12, cursor: 'pointer', boxShadow: '0 6px 14px rgba(17,24,39,0.05)'
                  }}
                >
                  Einstellungen anpassen
                </button>
                <button
                  onClick={handleAccept}
                  style={{
                    padding: '10px 20px', fontSize: 14, fontWeight: 600, color: '#374151', background: '#fff', border: '1px solid #d1d5db',
                    borderRadius: 12, cursor: 'pointer', boxShadow: '0 6px 14px rgba(17,24,39,0.05)'
                  }}
                >
                  Nur funktionale Cookies
                </button>
                <button
                  onClick={handleAcceptAll}
                  style={{
                    padding: '10px 20px', fontSize: 14, fontWeight: 700, color: '#fff', background: 'linear-gradient(135deg, #16a34a, #15803d)', border: '1px solid transparent',
                    borderRadius: 12, cursor: 'pointer', boxShadow: '0 12px 24px rgba(22,163,74,0.2)'
                  }}
                >
                  Alle akzeptieren
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


